import { render, staticRenderFns } from "./ProjectSettings.vue?vue&type=template&id=e99cee54"
import script from "./ProjectSettings.vue?vue&type=script&lang=js"
export * from "./ProjectSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports